function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 3a9 9 0 109 9 9.01 9.01 0 00-9-9zm7.5 9a7.465 7.465 0 01-1.695 4.744L13.06 12l4.744-4.744A7.465 7.465 0 0119.5 12zm-6.75-7.463v5.652l3.994-3.993a7.467 7.467 0 00-3.994-1.659zM4.5 12a7.51 7.51 0 016.75-7.463v7.152l-5.054 5.055A7.465 7.465 0 014.5 12zm7.5 1.06l-4.744 4.744a7.484 7.484 0 009.488 0L12 13.061z",
  clipRule: "evenodd"
}));